import ThemeCard from "./ThemeCard";

export default function ThemeSelectionStep({ themes, form, updateField }) {
    return (
        <div className="wg-step-shell">
            <div className="wg-mode-bar">
                <div>
                    <h2 className="wg-section-title">Theme Selection</h2>
                    <p className="wg-section-subtitle">
                        Pick the visual style. Layout and structure will adapt automatically
                        based on your business type.
                    </p>
                </div>
            </div>

            <div className="wg-block">
                <div className="wg-block-header">
                    <div>
                        <h3 className="wg-block-title">Choose Your Theme</h3>
                        <p className="wg-block-subtitle">
                            Select the style direction that best fits your brand. You can still
                            refine content and layout in the next step.
                        </p>
                    </div>
                </div>

                <div className="wg-theme-grid">
                    {themes.map((theme) => (
                        <ThemeCard
                            key={theme.key}
                            theme={theme}
                            selected={form.themeKey === theme.key}
                            onClick={() => updateField("themeKey", theme.key)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}